import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsolidatedEquipmentAvailabilityService {

  private readonly _httpClient = inject(HttpClient);

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, orderTypeId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('orderTypeId', orderTypeId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedEquipmentAvailability.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getConsolidatedEquipmentAvailability(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], orderTypeId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('orderTypeId', orderTypeId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedEquipmentAvailability.GetConsolidatedEquipmentAvailabilityAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedEquipmentAvailability.GetColumnsForGeneralConsultationAsync}`);
  }

  getConsolidatedEquipmentAvailabilityReport(articleId: number): Observable<CustomTableReport[]> {
    const params = new HttpParams().set('articleId', articleId);
    return this._httpClient.post<CustomTableReport[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedEquipmentAvailability.GetConsolidatedEquipmentAvailabilityReportAsync}`,
      null, { params: params }
    );
  }
}
